import * as angular from "angular"
import { IOmniaSession, IUibModalScope, LocaleString } from "../../types"
import { IOmniaUser } from "../../user"
import { defineDirective } from "../../utils/angular"
import { IUsersApi } from "../types"

/** @internal */
export const msgPasswordRule = "Your password must be at least 8 characters long, and contain at least one uppercase letter, one lowercase letter, and one number."

const errors = {
    "notset": "The new password is required" as LocaleString,
    "invalid": msgPasswordRule,
    "different": "The passwords do not match" as LocaleString
}

/** @internal */
export function getPasswordError(err: string) {
    return errors[err] || err
}

/** @internal */
export class ChangePasswordCtrl {

    static create(): ng.IDirective {

        return defineDirective(ChangePasswordCtrl, "shared/user/password/password.html", {});

    }

    private $scope: IUibModalScope;

    private form: ng.IFormController;
    private user: IOmniaUser;
    username = ""

    private newPassword: string;
    private newPasswordConfirmation: string;

    passwordInvalid: boolean;
    passwordDifferent: boolean;

    static $inject = ["$scope", "$q", "OmniaSession", "OmniaUserApi"];

    passwordRuleLabel = msgPasswordRule

    constructor($scope: ng.IScope, private $q: ng.IQService, private session: IOmniaSession, private svc: IUsersApi) {
        this.$scope = <IUibModalScope>$scope.$parent;
        this.user = angular.merge({}, session.currentUser);
        this.username = this.user.Email
    }

    cancel() {
        this.$scope.$close();
    }

    canSave(): boolean {

        const error = checkPassword(this.newPassword, this.newPasswordConfirmation)

        this.passwordInvalid = (error == "invalid")
        this.passwordDifferent = (error == "different")

        if (error) {
            return false
        }

        return this.form && this.form.$valid

    }

    save() {
        this.svc.resetPassword(this.newPassword).then(() => {
            this.session.logout();
        });
    }

    close() {
        this.$scope.$close();
    }
}


export function checkPassword(password: string, confirmation: string) {

    if (!password) {
        return "notset"
    }

    const minLength = 8

    const rules = [
        (a: string) => a.length >= minLength,
        (a: string) => /[a-z]/.test(a),
        (a: string) => /[A-Z]/.test(a),
        (a: string) => /[0-9]/.test(a)
    ]


    if (!rules.every(r => r(password))) {
        return "invalid"
    }

    if (password !== confirmation) {
        return "different"
    }

}
